import type { FAQ } from './sections';
import type { RefundPolicy } from './sections/RefundPolicy/types';

export type HighlightsDuration = {
  days: number;
  hours: number;
  minutes: number;
  totalSeconds: number;
};

export type Highlights = {
  duration?: HighlightsDuration;
  durationString?: string;
  age_restriction?: string;
  accepts_refunds?: boolean;
  freeParking?: boolean;
  paidParking?: boolean;
  parking?: boolean;
  isOnline?: boolean;
  doorTime?: string;
};

export enum CardSize {
  STRETCHED = 'stretched',
  CONTAINED = 'contained',
}

export type GoodToKnowProps = {
  faqs?: FAQ[];
  highlights?: Highlights;
  refundPolicy?: RefundPolicy;
  showViewAll?: boolean;
  cardSize?: CardSize;
};
